var TextureProjector = (function () {
    function TextureProjector() {
    }
    return TextureProjector;
}());
export { TextureProjector };
